export const createAccount = '/onboard/create-account';
export const verify = '/onboard/verify';
export const welcome = '/onboard/welcome';
export const totalLoansSummary = '/onboard/total-loans-summary';
export const questions = '/onboard/questions';
export const loanInfo = '/onboard/loan-info';
export const finish = '/';
export const plans = '/plans';
export const loadingRecommendations = '/onboard/rec-loading';
